import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {isPlatformBrowser} from '@angular/common';

const headers = new HttpHeaders({
  'Content-Type':  'application/json',
  'Access-Control-Allow-Origin': '*'
});

@Injectable({
  providedIn: 'root'
})

export class CoinService {

  constructor(
    private http: HttpClient
  ) { }

  saveObject(data: { launch: string; }) {
    data.launch = this.transformDate(data.launch);
    return this.http.post( environment.apiUrl + '/coins/saveObject', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getObjects() {
    return this.http.get(environment.apiUrl + '/coins/getObjects', {headers})
      .pipe(map((res: any) => {
        return res;
      }));
  }

  vote(data: { coin: any; }) {
    return this.http.post( environment.apiUrl + '/vote', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getObject(slug: string | number | boolean) {
    const params = new HttpParams().set('slug', slug);
    return this.http.get(environment.apiUrl + '/coins/getObject', {params, headers})
      .pipe(map((res: any) => {
        return res;
      }));
  }

  adminGetCoinExchanges(id: number) {
    const params = new HttpParams().set('coin_id', id);
    return this.http.get(environment.apiUrl + '/admin/coinExchange/getObjects', {params, headers})
      .pipe(map((res: any) => {
        return res;
      }));
  }

  adminSaveCoinExchange(data: any) {
    return this.http.post( environment.apiUrl + '/admin/coinExchange/saveObject', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  adminRemoveCoinExchange(id: number) {
    const params = new HttpParams().set('id', id);
    return this.http.get(environment.apiUrl + '/admin/coinExchange/deleteObject', {params, headers})
      .pipe(map((res: any) => {
        return res;
      }));
  }

  adminSaveObject(data: { launch: string; featured_start: string; featured: string; }) {
    data.launch = this.transformDate(data.launch);
    data.featured_start = this.transformDate(data.featured_start);
    data.featured = this.transformDate(data.featured);
    return this.http.post( environment.apiUrl + '/admin/coins/saveObject', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  adminGetObject(id: string | number | boolean) {
    const params = new HttpParams().set('id', id);
    return this.http.get(environment.apiUrl + '/admin/coins/getObject', {params, headers})
      .pipe(map((res: any) => {
        return res;
      }));
  }

  adminGetObjects(keyword: string | null, page: number | null) {
    let params = new HttpParams();

    if (keyword) {
      params = params.append('q' , keyword);
    }

    if(page !== null && page > 1){
      params = params.append('page', page);
    }

    return this.http.get(environment.apiUrl + '/admin/coins/getObjects2', {params, headers})
      .pipe(map((res: any) => {
        return res;
      }));
  }

  adminRemoveObject(id: string | number | boolean) {
    const params = new HttpParams().set('id', id);
    return this.http.get( environment.apiUrl + '/admin/coins/deleteObject', {params, headers})
      .pipe(map((res: any) => {
        return res;
      }));
  }

  transformDate(date: string | number | Date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return year + '-' + month + '-' + day;
  }

}
